module.exports = __webpack_public_path__ + "static/fun-time/games/page009_game0/audio//11_green.mp3";